<template>
	<main>
		<ReactivateView v-if="isProjectPaused || isMarketPaused" />
		<DashboardSEOView v-else-if="selectedVisibility == 'kw'" />
		<DashboardGEOView v-else-if="selectedVisibility == 'ai'" />
	</main>
</template>

<script setup>
import { ref, watch, computed, onBeforeMount } from 'vue';
import { storeToRefs } from 'pinia';
import DashboardSEOView from '@/views/dashboard/DashboardSEOView.vue';
import DashboardGEOView from '@/views/dashboard/DashboardGEOView.vue';
import ReactivateView from '@/views/ReactivateView.vue';

import { useSubNavigationStore } from '@/store/global/subNavigation';
import { useMarketStore } from '@/store/global/market';

const subNavigationStore = useSubNavigationStore();
const { selectedVisibility } = storeToRefs(subNavigationStore);

const marketStore = useMarketStore();
const { projects, selectedProject, markets, selectedMarket } = storeToRefs(marketStore);

function getItemById(items, id) {
	return items.find(item => item.id === id) || null;
}

const selectedProjectItem = computed(() => getItemById(projects.value, selectedProject.value));
const selectedMarketItem = computed(() => getItemById(markets.value, selectedMarket.value));
const isProjectPaused = computed(() => selectedProjectItem.value?.type === 'paused');
const isMarketPaused = computed(() => selectedMarketItem.value?.type === 'paused');

</script>

<style lang="scss" scoped></style>
